<template>
  <div id="watch-show" class="row-v2">
    <div class="col left">
      <div class="col__box">
        <!-- <span style="display: none">

        </span> -->
        <!-- <player-component :video-url="source"/> -->
        <iframe
          id="watch-id"
          sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-popups-to-escape-sandbox"
          :src="sourceIframe"
          name="watch-id"
          allowfullscreen="allowfullscreen" frameborder="0" crosside allow="autoplay" :key="sourceIframe"></iframe>
        <video width="320" height="240" controls>
          <source src="https://elite-youthful-longship.glitch.me/videos/1zhblNSk8ehcRbTbvWaUbqKYoTvvZhWqx" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <h1 class="name">{{episode.name}}
          <watch-late-component :slug="episode.slug" :id="episode.id" />
        </h1>
        <div class="files">
          File: <a href="#" onclick="return false" title="Next">Next</a>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>File</th>
                  <th>Stream</th>
                  <th>ID</th>
                  <th>Sub</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="file in files" v-bind:key="file.drive_id">
                  <td><a :href="`https://drive.google.com/file/d/${file.drive_id}/preview?start=1`" @click="setSourceByDriveId(file.drive_id)" onclick="return false" target="watch-id" :title="file.info.name">{{file.info.name}}</a></td>
                  <td><a :href="`https://elite-youthful-longship.glitch.me/videos/${file.drive_id}/`" @click="setSourceByStream(file.drive_id)" onclick="return false" target="watch-id" :title="file.info.name">Stream</a></td>
                  <td class="w-1">{{array_get(file, 'drive_id', '')}}</td>
                  <td class="text-center"><a :href="`https://drive.google.com/video/captions/edit?id=${file.drive_id}`" title="Sub" target="_blank" rel="noopener noreferrer">
                      <i class="fa fa-link"></i>
                    </a></td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--    <ul>
            <li v-for="file in files" v-bind:key="file.drive_id">
              <a href="" @click="setSource(file.drive_id)" onclick="return false" target="watch-id" :title="file.info.name">{{file.info.name}}</a> | {{array_get(file, 'drive_id', '')}}
            </li>
          </ul> -->
        </div>
        <movie-infomation-component v-if="episode && episode.movie" :movie="episode.movie" :url="url" />
      </div>
    </div>
    <div class="col right">
      <div class="col__box" v-if="movie != null && movie.episodes.length > 1">
        <movie-episodes-component :movie="movie" />
      </div>
      <div class="col__box">
        <h2>{{$t('recomentdation')}}</h2>
        <ul class="list-unstyled" v-if="recommentEpisodes != null">
          <li v-for="episode in recommentEpisodes" :key="episode.slug">
            <episode-item-horizontal-component :episode="episode" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
'use strict';
import Helper from '@/Helper';
export default {
  name: 'watch-show',
  components: {
    ...Helper.loadComponents([
      'player',
      'movie-infomation',
      'episode-item-horizontal',
      'watch-late',
      'movie-episodes',
    ]),
  },
  data() {
    return {
      sourceIframe: '',
      source: '',
      files: [],
      movie: null,
      url: location.href,
      hasTryReload: false,
      recommentEpisodes: null,
      episode: {
        name: '',
        slug: '',
      },
    };
  },
  methods: {
    setSourceByStream(driveId) {
      // this.source = `https://elite-youthful-longship.glitch.me/videos/${driveId}`;
      this.source = `http://localhost:3000/videos/${driveId}`;
      // this.sourceIframe = `http://localhost:3000/videos/${driveId}`;
      this.sourceIframe = `https://drive.google.com/file/d/${driveId}/preview?start=1`;

    },
    setSourceByDriveId(driveId) {
      this.source = `https://drive.google.com/file/d/${driveId}/preview?start=1`;
    },
    async loadFilesOfEpisode(episodeSlug) {
      var files = await window.api.episodes[episodeSlug].files.get();
      files.data.forEach(e => e.info = JSON.parse(e.info));
      this.$set(this, 'files', files.data);
      // this.setSourceByDriveId(this.array_get(files.data[0], 'drive_id', ''));
      var driverId = this.array_get(files.data[0], 'drive_id', '');
      this.setSourceByStream(driverId);
    },
    async loadEpisode(episodeSlug) {
      var episode = await window.api.episodes[episodeSlug].get();
      window.Vue.set(this, 'episode', episode);
    },
    async loadMovieOfEpisode(episodeSlug) {
      var movie = await window.api.episodes[episodeSlug].movie.get();
      this.$set(this, 'movie', movie);
    },
    async loadRecomment(slug) {
      this.recommentEpisodes = await window.api.recommentEpisodes[slug].get({ with: 'movie' });

    },
    async load() {
      let slug = this.$route.params.slug;
      this.loadEpisode(slug);
      this.loadFilesOfEpisode(slug);
      this.loadMovieOfEpisode(slug);
      this.loadRecomment(slug);
    },
  },
  created() {
    this.load();
  },
  watch: {
    $route() {
      this.load();
    },
  },
}

</script>
